import { createReducer, on } from '@ngrx/store';
import { fetchTheme, fetchThemeFail, fetchThemeSuccess } from './theme.actions';
import { ThemeRequest } from '../theme.model';
import { initialStatus, loadingStatus } from '../../../../../../../core/models/request-status.model';

const initialState: ThemeRequest = {
  ...initialStatus,
};

export const themeReducer = createReducer(
  initialState,

  on(fetchTheme, state => ({
    ...state,
    ...loadingStatus,
  })),

  on(fetchThemeSuccess, fetchThemeFail, (state, { themeRequest }: { type: string; themeRequest: ThemeRequest }) => ({
    ...state,
    ...themeRequest,
  })),
);
